/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.offerings.create.lifecycle.modals.remove.controllers', [
  'ui.bootstrap'
])

.controller('MembershipOfferingsCreateLifecycleModalsRemoveController', ['$scope', '$uibModalInstance', 'currentCategory', function($scope, $uibModalInstance, currentCategory) {

    $scope.membershipOfferingsCreateLifecycleModalsRemove = {

      model: {},

      init: function() {
        if (currentCategory) {
          this.model = currentCategory;
        }
      },

      done: function() {
        $uibModalInstance.close();
      },

      cancel: function() {
        $uibModalInstance.dismiss();
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.membershipOfferingsCreateLifecycleModalsRemove.init();

}]);